/**
 * Portaria / Controle de Acesso — Sala de Guerra (preview estratégico).
 * Dados simulados até integração RFID e leitores em produção.
 * Implementação operacional legada preservada em git history; UI atual = AcessoWarRoomDesktop.
 */
import { AcessoWarRoomDesktop } from './AcessoWarRoomDesktop';

export function AcessoPage() {
  return <AcessoWarRoomDesktop />;
}
